import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

/**
 * Visible breadcrumbs + BreadcrumbList JSON-LD.
 * crumbs: [{ name, path?: string }]  (last crumb has no path = current page)
 */
export default function Breadcrumbs({ crumbs, dark = false }) {
  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: crumbs.map((c, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: c.name,
      ...(c.path
        ? { item: `https://yourelitehomecare.com${c.path}` }
        : {}),
    })),
  };

  const text = dark ? "text-white/70" : "text-navy-500";
  const active = dark ? "text-gold-300" : "text-gold-500";
  const hover = dark ? "hover:text-white" : "hover:text-navy-900";

  return (
    <>
      <nav
        aria-label="Breadcrumb"
        data-testid="breadcrumbs"
        className={`flex items-center flex-wrap gap-1.5 text-xs tracking-wide ${text}`}
      >
        {crumbs.map((c, i) => {
          const isLast = i === crumbs.length - 1;
          return (
            <React.Fragment key={c.name}>
              {i > 0 && <ChevronRight className="h-3.5 w-3.5 opacity-60" />}
              {isLast || !c.path ? (
                <span
                  className={isLast ? active : ""}
                  data-testid={`breadcrumb-${i}`}
                >
                  {i === 0 ? (
                    <span className="inline-flex items-center gap-1">
                      <Home className="h-3 w-3" />
                      {c.name}
                    </span>
                  ) : (
                    c.name
                  )}
                </span>
              ) : (
                <Link
                  to={c.path}
                  data-testid={`breadcrumb-${i}`}
                  className={`transition-colors ${hover}`}
                >
                  {i === 0 ? (
                    <span className="inline-flex items-center gap-1">
                      <Home className="h-3 w-3" />
                      {c.name}
                    </span>
                  ) : (
                    c.name
                  )}
                </Link>
              )}
            </React.Fragment>
          );
        })}
      </nav>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
    </>
  );
}
